"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const renderer_1 = require("@react-pdf/renderer");
const styles = renderer_1.StyleSheet.create({
    footer: {
        flexDirection: 'row',
        position: 'absolute',
        bottom: 15,
        left: 0,
        right: 0,
    },
    company: {
        fontSize: 9,
    },
    footerLeft: {
        flexDirection: 'column',
        width: '50%',
        textAlign: 'left',
        paddingLeft: 60,
        fontSize: 8,
    },
    footerRight: {
        flexDirection: 'column',
        justifyContent: 'flex-end',
        width: '50%',
        textAlign: 'right',
        paddingRight: 60,
        fontSize: 8,
    },
});
const InvoiceFooter = ({ invoice }) => (react_1.default.createElement(renderer_1.View, { style: styles.footer, fixed: true },
    react_1.default.createElement(renderer_1.View, { style: styles.footerLeft },
        react_1.default.createElement(renderer_1.Text, { style: styles.company }, invoice.company),
        react_1.default.createElement(renderer_1.Text, null, invoice.companyCapital),
        react_1.default.createElement(renderer_1.Text, null, invoice.companySiren)),
    react_1.default.createElement(renderer_1.View, { style: styles.footerRight },
        react_1.default.createElement(renderer_1.Text, null,
            "N\u00B0T.V.A. intra comm : ",
            invoice.tvaIntra),
        react_1.default.createElement(renderer_1.Text, null,
            "SIRET : ",
            invoice.companySiret))));
exports.default = InvoiceFooter;
